import { render, staticRenderFns } from "./ListOfNews.vue?vue&type=template&id=763971c7&"
import script from "./ListOfNews.vue?vue&type=script&lang=js&"
export * from "./ListOfNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports